// eslint-disable-next-line import/no-extraneous-dependencies
import { usePostHog } from 'posthog-js/react';
import { useCallback } from 'react';

interface CaptureEventProperties {
  page?: string;
  component?: string;
  [key: string]: string | number | boolean | undefined;
}

export const usePostHogCapture = () => {
  const posthog = usePostHog();

  const capture = useCallback(
    (eventName: string, properties?: CaptureEventProperties) => {
      if (import.meta.env.MODE === 'development') {
        // eslint-disable-next-line no-console
        console.log('[PostHog] capture', eventName, properties);
      }

      posthog.capture(eventName, properties);
    },
    [posthog],
  );

  return capture;
};
